import { render, staticRenderFns } from "./ProductCwsLogo.vue?vue&type=template&id=8aa25d4a&scoped=true&"
import script from "./ProductCwsLogo.vue?vue&type=script&lang=ts&"
export * from "./ProductCwsLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa25d4a",
  null
  
)

export default component.exports